module.exports = __webpack_public_path__ + "images/Like.effe4d9223436f1d72363f1412381a9f.svg";